import React from 'react'
import { Row, Col } from 'react-bootstrap'
import * as moment from 'moment'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import profileThumbnail from '../../../../../../../img/profile.png'
import { requestDeleteListCompanyNote } from '../../../../../../../redux/actions/single-list'
import './style.scss'

const Index = ({singleNote, index, arr, match}) => {

	const dispatch = useDispatch()

	const companyId = useSelector(state => state.activeCompany.activeCompany.id)

	const clickDeleteNote = key => {
		dispatch(requestDeleteListCompanyNote({companyId: companyId, activeClient: match.params.id, key: key}))
		//dispatch(requestDeleteSingleListCompanyNote({companyId: companyId}))
		//dispatch(requestDeleteSingleClientNote({companyId: companyId, activeClient: match.params.id, key: key}))
		//requestDeleteSingleClientNote
	}

	return(
			<div className={index === arr.length - 1 ? "single-list-note-container last":"single-list-note-container"}>
				<Row className="upper-note-row">
					<Col className="thumbnail-col">
						<img alt={singleNote.author} className="notes-thumbnail" src={singleNote.thumbnail ? singleNote.thumbnail:profileThumbnail}/>
					</Col>
					<Col className="note-information-col my-auto">
						<h5 className="note-name-label">{singleNote.author}</h5>
						<p className="note-timestamp">{moment.unix(singleNote.timestamp).format('HH:MM DD/MM/YYYY')}</p>
					</Col>
					<Col className="action-col text-right my-auto col">
						<button onClick={() => clickDeleteNote(singleNote.key)} className="delete-button"><i className="far fa-trash-alt"></i></button>
					</Col>
				</Row>
				<Row className="note-content-row">
					<Col className="content-col">
						<p className="single-note">{singleNote.content}</p>
					</Col>
				</Row>
			</div>
	)
}

export default withRouter(Index)

